module.exports = __webpack_public_path__ + "img/CAKE.11f7c3a7.png";